var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"visible":_vm.showVideoPop,"title":"Basic Modal","width":"100%","wrapClassName":"full-modal","footer":null},on:{"cancel":_vm.closePop}},[_c('video',{attrs:{"autoplay":"","controls":"","src":"https://static.yangtao.com/static/home/gettingStarted.mp4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }